'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    theme = Object.assign({}, baseTheme(theme), theme);

    if (this.props.dark) {
        theme.color = theme.tInversion;
        // theme elDarkest no transparency
        theme.borderColor = theme.elBlack;
        theme.background = theme.elBlack;
    }

    var labelStyle = {
        whiteSpace: 'normal',
        wordWrap: 'normal'
    };

    if (this.props.short) {
        theme.maxWidth = theme.gutter * 40 + 'px';
        theme.minWidth = theme.gutter * 20 + 'px';
    } else if (this.props.middle) {
        theme.maxWidth = theme.gutter * 60 + 'px';
        theme.minWidth = theme.gutter * 40 + 'px';
    } else if (this.props.long) {
        theme.maxWidth = theme.gutter * 70 + 'px';
        theme.minWidth = theme.gutter * 50 + 'px';
    } else if (this.props.wide) {
        theme.maxWidth = 'auto';
        theme.minWidth = 'auto';
    }

    if (!this.props.multiLine) {
        labelStyle = {
            textWrap: 'none',
            whiteSpace: 'nowrap',
            wordWrap: 'normal'
        };
    }

    if (this.props.inline) {
        theme.display = 'inline-block';
    }

    var position = {
        top: 0,
        left: 'calc(100% + ' + theme.gutter * 2 + 'px)',
        right: 'auto',
        bottom: 'auto'
    };

    var trianglePosition = {
        left: theme.triangleWidth * -1 + 'px',
        top: theme.triangleWidth * -1 + 'px',
        right: 'auto',
        bottom: 'auto'
    };

    if (this.state.position === 'top-left') {
        position = {
            top: 'auto',
            left: 0,
            right: 'auto',
            bottom: 'calc(100% + ' + theme.gutter * 2 + 'px)'
        };
        trianglePosition = {
            left: 'calc(15% - ' + theme.triangleWidth / 2 + 'px)',
            right: 'auto',
            top: 'auto',
            bottom: theme.triangleWidth * -1 + 'px'
        };
    } else if (this.state.position === 'top-right') {
        position = {
            top: 'auto',
            right: 0,
            left: 'auto',
            bottom: 'calc(100% + ' + theme.gutter * 2 + 'px)'
        };
        trianglePosition = {
            right: 'calc(15% - ' + theme.triangleWidth / 2 + 'px)',
            left: 'auto',
            top: 'auto',
            bottom: theme.triangleWidth * -1 + 'px'
        };
    } else if (this.state.position === 'right-top') {
        position = {
            top: 0,
            right: 'auto',
            left: 'calc(100% + ' + theme.gutter * 2 + 'px)',
            bottom: 'auto'
        };
        trianglePosition = {
            left: theme.triangleWidth * -1 + 'px',
            right: 'auto',
            top: 'calc(15% - ' + theme.triangleWidth / 2 + 'px)',
            bottom: 'auto'
        };
    } else if (this.state.position === 'right-bottom') {
        position = {
            top: 'auto',
            right: 'auto',
            left: 'calc(100% + ' + theme.gutter * 2 + 'px)',
            bottom: 0
        };
        trianglePosition = {
            left: theme.triangleWidth * -1 + 'px',
            right: 'auto',
            top: 'auto',
            bottom: 'calc(15% - ' + theme.triangleWidth / 2 + 'px)'
        };
    } else if (this.state.position === 'bottom-right') {
        position = {
            top: 'calc(100% + ' + theme.gutter * 2 + 'px)',
            right: 0,
            left: 'auto',
            bottom: 'auto'
        };
        trianglePosition = {
            top: theme.triangleWidth * -1 + 'px',
            right: 'calc(15% - ' + theme.triangleWidth / 2 + 'px)',
            left: 'auto',
            bottom: 'auto'
        };
    } else if (this.state.position === 'bottom-left') {
        position = {
            top: 'calc(100% + ' + theme.gutter * 2 + 'px)',
            right: 'auto',
            left: 0,
            bottom: 'auto'
        };
        trianglePosition = {
            top: theme.triangleWidth * -1 + 'px',
            right: 'auto',
            left: 'calc(15% - ' + theme.triangleWidth / 2 + 'px)',
            bottom: 'auto'
        };
    } else if (this.state.position === 'left-top') {
        position = {
            top: 0,
            left: 'auto',
            right: 'calc(100% + ' + theme.gutter * 2 + 'px)',
            bottom: 'auto'
        };
        trianglePosition = {
            left: 'auto',
            right: theme.triangleWidth * -1 + 'px',
            top: 'calc(15% - ' + theme.triangleWidth / 2 + 'px)',
            bottom: 'auto'
        };
    } else if (this.state.position === 'left-bottom') {
        position = {
            top: 'auto',
            left: 'auto',
            right: 'calc(100% + ' + theme.gutter * 2 + 'px)',
            bottom: 0
        };
        trianglePosition = {
            left: 'auto',
            right: theme.triangleWidth * -1 + 'px',
            top: 'auto',
            bottom: 'calc(15% - ' + theme.triangleWidth / 2 + 'px)'
        };
    }

    if (theme.top || theme.left) {
        position.transform = 'translateX(' + (theme.left || 0) + 'px) translateY(' + (theme.top || 0) + 'px)';
    }

    var styleList = _aphroditeJss.StyleSheet.create({
        root: {
            position: 'relative',
            display: theme.display,
            textAlign: theme.textAlign
        },
        wrapper: Object.assign({
            position: 'absolute',
            boxSizing: 'border-box',
            zIndex: theme.zIndex,
            whiteSpace: 'normal',
            boxShadow: theme.boxShadow
        }, position),
        triangle: Object.assign({
            position: 'absolute',
            width: theme.triangleWidth * 2 + 'px',
            height: theme.triangleWidth * 2 + 'px',
            background: theme.background,
            transform: 'rotate(45deg)'
        }, trianglePosition, {
            border: '0 none',
            boxShadow: theme.boxShadow,
            zIndex: 1
        }),
        label: Object.assign({}, labelStyle, {
            padding: theme.gutter + 'px',
            fontSize: theme.labelFontSize,
            lineHeight: theme.labelLineHeight,
            color: theme.color,
            textAlign: theme.textAlign,
            textTransform: 'none',
            maxWidth: theme.maxWidth,
            minWidth: theme.minWidth,
            zIndex: 2,
            backgroundColor: theme.background,
            border: '1px solid ' + theme.borderColor,
            borderRadius: '2px',
            position: 'relative',

            '& a': {
                color: theme.linkColor,
                textDecoration: 'none'
            }
        }),
        animation: {
            transition: 'opacity ' + theme.transitionDuration + ' ' + theme.transitionFunction,

            '&-enter': {
                opacity: 0
            },

            '&-enter-active': {
                opacity: 1
            },
            '&-exit': {
                opacity: 1
            },
            '&-exit-active': {
                opacity: 0
            }
        }
    });

    return {
        root: (0, _aphroditeJss.css)(styleList.root),
        label: (0, _aphroditeJss.css)(styleList.label),
        wrapper: (0, _aphroditeJss.css)(styleList.wrapper),
        animation: (0, _aphroditeJss.css)(styleList.animation),
        triangle: (0, _aphroditeJss.css)(styleList.triangle)
    };
};

var _aphroditeJss = require('aphrodite-jss');

var baseTheme = function baseTheme(theme) {
    return {
        display: 'block',
        borderColor: theme.elPrimary,
        boxShadow: '0 8px 12px 0 ' + theme.elShadow + ', 0 6px 12px 0 ' + theme.elShadow,
        background: theme.elPrimary,
        color: theme.tInactive,
        linkColor: theme.tAccent,
        zIndex: theme.zOverlay,
        labelFontSize: theme.tsXSmall,
        labelLineHeight: theme.tlXSmall,
        triangleWidth: theme.gutter / 2,
        textAlign: 'left',
        // hint offset relative to current position
        top: 0,
        left: 0,
        maxWidth: theme.gutter * 30 + 'px',
        minWidth: theme.gutter * 20 + 'px'
    };
};